








import { Component, Prop, Vue } from "vue-property-decorator";
import { BILLINGS as billingsDao } from "@/api/BillingsDao";
//@ts-ignore
import { loadStripe } from '@stripe/stripe-js';

@Component({
    components: {}
})
export default class Checkout extends Vue {

    @Prop()
    products!: string[];

    @Prop()
    coupon!: string;

    @Prop()
    fromUrl!: string;

    @Prop()
    successUrl!: string;


    mounted() {
        this.redirectToCheckout()
    }

    private async redirectToCheckout() {
        let stripe = await loadStripe(process.env.VUE_APP_STRIPE_P_KEY || '');
        if (stripe == null) {
            return;
        }
        let session = await billingsDao.initiateCheckout(this.successUrl, this.fromUrl, this.products, this.coupon)
        Vue.$cookies.set('checkout-session', session.sessionId)
        const error = await stripe.redirectToCheckout({
            // Make the id field from the Checkout Session creation API response
            // available to this file, so you can provide it as parameter here
            // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
            sessionId: session.sessionId
        })
        console.log(session)
    }

}
